/**
 * CanvasFallback - static background shown while LeviathanCanvas loads.
 *
 * Matches the canvas ambient look: dark base, gold-tinted grid, subtle radial
 * gradient. No motion unless prefers-reduced-motion is false.
 */

const GRID_STYLE: React.CSSProperties = {
  backgroundImage: [
    'linear-gradient(to right, rgba(22,22,32,0.5) 1px, transparent 1px)',
    'linear-gradient(to bottom, rgba(22,22,32,0.5) 1px, transparent 1px)',
  ].join(', '),
  backgroundSize: '40px 40px',
  opacity: 0.12,
}

const RADIAL_STYLE: React.CSSProperties = {
  background:
    'radial-gradient(ellipse 80% 70% at 50% 40%, rgba(199,169,79,0.06) 0%, transparent 70%)',
}

export default function CanvasFallback() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: '#050507',
        zIndex: 0,
        pointerEvents: 'none',
      }}
    >
      {/* Grid pattern */}
      <div style={{ position: 'absolute', inset: 0, ...GRID_STYLE }} />
      {/* Gold radial glow */}
      <div style={{ position: 'absolute', inset: 0, ...RADIAL_STYLE }} />
    </div>
  )
}
